export const SVG_ICONS = {
    logo: 'logo',
    dashboard: 'dashboard',
    dealers: 'dealers',
    mediaLibrary: 'mediaLibrary',
    channel: 'channel',
    directory: 'directory',
    search: 'search',
    chevron: 'chevron',
    chevronDown: 'chevron-down',
    profile: 'profile',
    profilePlaceholder: 'profile-placeholder',
    settings: 'settings',
    notification: 'notification',
    screens: 'screens',
    filter: 'filter',
    delete: 'delete',
    export: 'export',
    reset: 'reset',
    magnifying: 'icon-search',
    sparkles: 'sparkles',
    copy: 'copy',
    menu: 'menu',
    close: 'close',
    screenshot: 'screenshot',
    outlineTrash: 'outline-trash',
    refreshGreen: 'refresh-green',
    editPencil: 'pencil-edit',
    warning: 'warning',
    infoCircle: 'info-circle',
    pencilBox: 'pencil-box',
    lock: 'lock',
    barcode: 'barcode',
    gear: 'gear',
    tv: 'tv',
    play: 'play',
    upload: 'upload',
    ads: 'ads',
    arrowRotate: 'arrow-rotate',
    gridView: 'grid-view',
    listView: 'list-view',
    shield: 'shield',
    user: 'profile',
    mapFolded: 'map-folded',
    reports: 'reports',
    licenses: 'licenses',
    activity: 'activity',
    raspberryPi: 'raspberry',
    installations: 'installations',
    users: 'users',
    arrowUpRight: 'arrow-up-right',
    ncompassCursor: 'ncompass-cursor',
    accountDetails: 'account-details',
    cameraFilled: 'camera-filled',
    mail: 'mail',
};
